import { render, staticRenderFns } from "./ASidebar.vue?vue&type=template&id=35a1ed3c&"
import script from "./ASidebar.vue?vue&type=script&lang=js&"
export * from "./ASidebar.vue?vue&type=script&lang=js&"
import style0 from "./ASidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports